import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import GenAIAuthoringIndex from "../../components/GenAIAnswering2.0/GenAIAuthoringIndex";
import { LimitedUser } from '../../utils/utilityServices'

class GenAIAuthoring extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
            height: window.innerHeight,
        }
        if ((props && !props.match.params) ||
            (props && props.location && !props.location.state) ||
            (props && props.location && props.location.state && !props.location.state.attachedFiles) ) {

            props.history.push('/genAIAnswering');
        }
        if (props && props.history && props.history.action && props.history.action === "POP") {
            let path = (props.location && props.location.state && props.location.state.path) ? props.location.state.path : '/genAIAnswering';
            props.history.push(path);
        }
    }
    componentDidMount() {
        let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'))
        let userExists = localStorage.getItem('userExists');
        if (!userExists) {
            console.log('Access Denied');
            this.props.history.push('/');
        }
        let _function = JSON.parse(localStorage.getItem('function'));
        if (_function !== "Medical" && !userAccessGroup.includes(LimitedUser)) {
            console.log('Access Denied');
            this.props.history.push('/');
        }
        else {
            window.addEventListener("resize", this.updateDimensions);
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
      }    
    updateDimensions = () => {
        try {
            this.setState(
                { width: window.innerWidth, height: window.innerHeight });
        } catch (error) {
            this.setState({ error: error });
        }
    };

    render() {
        if (this.state.width >= 600 && this.state.width <= 1000) {
            return (<GenAIAuthoringIndex customWidth={this.state.width} customHeight={this.state.height} />)
        } else if (this.state.width > 1000) {
            return (<GenAIAuthoringIndex customWidth={this.state.width} customHeight={this.state.height} />)
        }
    }
}
export default withRouter(GenAIAuthoring);